import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/movies";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % total);
    }, 5000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (i: number) => setIndex((i + total) % total);

  return (
    <section className="relative w-full h-[440px] md:h-[560px] overflow-hidden">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 剧照`}
            title={`${slide.title} - 大师兄影视`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/20" />
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-8">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-4">
                  <i className="ri-fire-fill" />
                  {slide.tag}
                </span>
                <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-background-50 leading-tight">
                  {slide.title}
                </h2>
                <p className="mt-4 text-sm md:text-lg text-background-100/90 leading-6 md:leading-7 max-w-xl">
                  {slide.subtitle}
                </p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <Link
                    to={`/detail/${slide.id}`}
                    className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    <i className="ri-play-circle-line text-lg" />
                    查看详情
                  </Link>
                  <Link
                    to="/category/全部"
                    className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
                  >
                    浏览全部影视
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={() => go(index - 1)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-background-50/15 border border-background-50/30 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        onClick={() => go(index + 1)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full bg-background-50/15 border border-background-50/30 text-background-50 hover:bg-background-50/30 transition-colors cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => go(i)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              i === index ? "w-8 bg-accent-500" : "w-3 bg-background-50/50 hover:bg-background-50/80"
            }`}
            aria-label={`切换到第${i + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}